import React from 'react'
import { JetSportBox } from '../../../components/BoxView/JetSportBox'
import { BoxContent } from '../../../components/BoxView/BoxContent'
import { StrucRow } from '../../../components/StructureElements/StrucRow'
import { StrucCol } from '../../../components/StructureElements/StrucCol'
import LogoEditorTool from './LogoEditorTool'
import { isAllowed } from '../../../shared/functions/isAllowed'
import { Role } from '../../../../core/models/entities/Role'
import { UploadLogo } from './UploadLogo'
import LoadingElement from '../../../components/loading-element/loading-element'
import { LogoOptions } from '../../../../core/models/entities/LogoOptions'
import { Organization } from '../../../../core/models/entities/Organization'
import { BaseLogo } from '../../../../core/models/entities/BaseLogo'
import { Profile } from '../../../../core/models/entities/Profile'
import { useLogoEditorViewModel } from '../vmHooks/useLogoEditorViewModel'
import { UploadPreview } from './UploadPreview'
import { enviroment } from '../../../../enviroment'

// Flag REACT_APP_LOGO_EDITOR_OPTIMISTIC_PREVIEW - build-time constant.
const optimisticEnabled = enviroment.logoEditorOptimisticPreviewEnabled

interface LogoEditorComponentProps {
  profile: Profile
  customers: Organization[]
  vendors: Organization[]
  options: LogoOptions
  selectedCustomerId?: number
  preselectedLogo?: BaseLogo
}

export function LogoEditorComponent({ profile, customers, vendors, options, selectedCustomerId, preselectedLogo }: LogoEditorComponentProps) {

  const {
    isLoading,
    isToolLoading,
    onFileUploadUpload,
    selectedLogo,
    uploadPreview,
    pendingColorChanges,
    onToolCancel,
    onToolSaveDraftChanges,
    onToolSaveApprovalChanges,
    onToolUpdateColor,
    approvalDialog,
    confirmationDialog,
    logoForm,
    updateForm,
    onResize
  } = useLogoEditorViewModel(profile, customers, vendors, options, selectedCustomerId, preselectedLogo)

  return (<>
    {approvalDialog}
    {confirmationDialog}
    <JetSportBox className={'relative'}>
      <BoxContent className={'px-0'}>
        <StrucRow className={'w-full flex-1'}>
          <StrucCol size={12} className={'relative'}>
            {
              selectedLogo
                ? <LogoEditorTool
                  pendingColorChanges={pendingColorChanges}
                  onCancel={onToolCancel}
                  onDraft={onToolSaveDraftChanges}
                  onCommit={onToolSaveApprovalChanges}
                  onUpdateColor={onToolUpdateColor} logo={selectedLogo} options={options}
                  isLoading={isToolLoading}
                  showCustomerInput={isAllowed(profile.userOrganizationInformations.role, Role.Vendor)}
                  customers={customers}
                  logoForm={logoForm}
                  updateForm={updateForm}
                  onResize={onResize}
                />
                : optimisticEnabled && uploadPreview
                  ? <UploadPreview file={uploadPreview.file} previewUrl={uploadPreview.previewUrl} />
                  : <UploadLogo onUploadImage={onFileUploadUpload} options={options} />
            }
            {/* Flag REACT_APP_LOGO_EDITOR_OPTIMISTIC_PREVIEW: no overlay - the tool shows
                its own progress strip and the upload shows the local preview. */}
            {isToolLoading && !optimisticEnabled && <LoadingElement transparent className={'rounded'} />}
          </StrucCol>
        </StrucRow>
      </BoxContent>
      {isLoading && <LoadingElement transparent showProgressBar className={'rounded'} />}
    </JetSportBox>
  </>
  )
}
